import * as React from "react";
import styled, { css } from "styled-components";

import { Button, TestWrapper, Margins, Input } from "@ui/Atoms";
import { Variant } from "@ui/Atoms/Button";
import { InputEvent } from "@ui/Atoms/Form";

interface Props {
  inputTestId?: string;
  buttonTestId?: string;
  isVertical?: boolean;
  inputName: string;
  isButtonDisabled?: boolean;
  onButtonClick: (e?: React.SyntheticEvent) => void;
  onInputChange: (e: InputEvent | string) => void;
  inputValue: string;
  errors?: string;
  buttonVariant?: Variant;
  isLoading?: boolean;
  translations: {
    buttonText: string;
    inputLabel: string;
  };
}

const InputWithSubmit = (props: Props): React.ReactElement => (
  <StyledForm isVertical={props.isVertical}>
    <Margins xs={[null, null, null, props.isVertical ? null : "base"]}>
      <div style={{ flexGrow: 1 }}>
        <TestWrapper testId={props.inputTestId}>
          <StyledInput
            isVertical={props.isVertical}
            name={props.inputName}
            id={props.inputName}
            onChange={props.onInputChange}
            value={props.inputValue}
            label={props.translations.inputLabel}
            errors={props.errors}
          />
        </TestWrapper>
      </div>
    </Margins>
    <TestWrapper testId={props.buttonTestId}>
      <Button
        disabled={!props.isLoading && props.isButtonDisabled}
        variant={props.buttonVariant || "green"}
        isLoading={props.isLoading}
        type="submit"
        onClick={props.onButtonClick}
      >
        {props.translations.buttonText}
      </Button>
    </TestWrapper>
  </StyledForm>
);

export { InputWithSubmit };

const StyledInput = styled(Input)<{ isVertical?: boolean }>`
  width: 100%;

  ${props => props.theme.breakpoints.desktop} {
    width: ${({ isVertical }) => (isVertical ? "100%" : "auto")};
  }

  ${({ isVertical }) =>
    isVertical &&
    css`
      margin-bottom: ${props => props.theme.margins.base};
    `}
`;

const StyledForm = styled.form<{ isVertical?: boolean }>`
  display: inline-flex;
  flex-direction: ${({ isVertical }) => (isVertical ? "column" : "row")};
  width: 100%;

  ${props => props.theme.breakpoints.tablet} {
    ${props => !props.isVertical && "width: auto;"}
  }
`;
